import styles from "css/Tab.module.css"
import Lib from "library"
import { animate } from "animejs"
import { useScroll } from "framer-motion"
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react"

const Tab = forwardRef(({ tabs, className, children, bar, type, liClass, liStyle, style, setTarget = null, currentTarget = 0 }, ref) => {
	useImperativeHandle(ref, () => {
		return { setTab }
	})

	const contents = useRef()
	const { scrollX } = useScroll({ container: contents })
	const [scrollBehaviorSupport, setScrollBehaviorSupport] = useState(false)
	const [active, setActive] = useState()
	const [existActive, setExistActive] =useState();

	const tabStyle = Lib.getStyle(className, styles)

	const tab = useRef()
	const timer = useRef(null)

	const setTab = (idx) => {
		const to = idx * contents.current.clientWidth
		// if (scrollBehaviorSupport) {
		// 	contents.current.scrollTo(to, 0)
		// } else {
		contents.current.classList.remove("xMandatory")
		animate(contents.current,{
			
			scrollLeft: to,
			duration: 300,
			ease: "inOutQuad",
			onComplete() {
				if (contents.current) {
					contents.current.scrollLeft = to
					contents.current.classList.add("xMandatory")
				}
			},
		})
		setTarget && setTarget(idx)
		setActive(idx)
		// }
	}

	const onClick = (e) => {
		const target = e.currentTarget || e.target
		const index = Lib.index(target)
		console.log('selected index : ' + index)
		setTab(index)
	}

	const getCurrent = () => Math.round((scrollX.current / contents.current.scrollWidth) * contents.current.childElementCount) + 1 || 1

	const bindScrollEvent = () => {
		contents.current.addEventListener("scroll", (e) => {
			const n = getCurrent()
			if (tab.current) {
				tab.current.querySelector(`.${styles.on}`)?.classList.remove(`${styles.on}`)
				const active = tab.current.querySelector(`:nth-child(${n})`)
				if (active) {
					active.classList.add(`${styles.on}`)
					const rect = active.getBoundingClientRect()
					const screenWidth = window.screen?.availWidth || window.innerWidth
					const parent = active.parentElement
					if (rect.width + rect.x > screenWidth) {
						parent.scrollTo(rect.x, 0)
					} else if (rect.x < 0) {
						parent.scrollTo(rect.x * -1, 0)
					}
				}
			}
		})
	}

	const bindScrollDBound = () => {
		contents.current.addEventListener("scroll", (e) => {
			const n = getCurrent() - 1
			if (timer.current) {
				clearTimeout(timer.current)
			}
			timer.current = setTimeout(() => {
				setTarget && setTarget(n)
			}, 200)
		})
	}

	useEffect(() => {
		bindScrollDBound()
		bindScrollEvent()
		if (typeof document.body.style.scrollBehavior !== "undefined") setScrollBehaviorSupport(true)
		active && setTab(active)
		console.log('current index : ' + currentTarget)
		setTab(currentTarget)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		setTab(currentTarget)
	}, [currentTarget])

	useEffect(() => {
		let existActive = false;
		if (tabs && tabs.length > 0) {
			tabs.forEach((item) => {
				if (item?.active) {
					existActive = true;
				}
			});

			if (!existActive) {
				setExistActive(false);
			} else {
				setExistActive(true);
			}
		}
	}, [tabs]);

	return (
		<>
			<ul ref={tab} className={`${styles.Tabs} ${tabStyle} ${type === "small" ? styles.small : ""}`} style={style}>
				{tabs && tabs.map((item, index) => {
					return (
						<li onClick={onClick} className={`${styles.tab} ${existActive && item.active ? styles.on : !existActive && index === 0 ? styles.on : ""}`} key={index}>
							<span>{item.title}</span>
						</li>
					)
				})}
			</ul>
			{bar && bar}
			<ul ref={contents} className={styles.TabContents + " xMandatory"}>
				{children &&
					children.map &&
					children.map((child, index) => {
						return (
							<li key={index} className={liClass} style={liStyle}>
								{child}
							</li>
						)
					})}
			</ul>
		</>
	)
})

export default React.memo(Tab)
